import { useEffect } from "react";

const setThemeColor = (color) => {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", color);
};

// Fullscreen white surface + keep screen awake (max perceived brightness, bank-app style).
// Fullscreen toggling reflows the whole page (looks like a reload), so it is disabled.
export const requestBrightSurface = () => {};

export const useScreenBoost = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    let lock = null;
    const previous = document.querySelector('meta[name="theme-color"]')?.getAttribute("content") || "#e8ecf3";
    document.body.classList.add("capture-bright");
    setThemeColor("#FFFFFF");
    navigator.wakeLock
      ?.request("screen")
      .then((l) => {
        lock = l;
      })
      .catch(() => {});
    return () => {
      document.body.classList.remove("capture-bright");
      setThemeColor(previous);
      lock?.release().catch(() => {});
      if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {});
    };
  }, [active]);
};
